import React, { Component, Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import moment from 'moment'
import { withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import { setPricing, getCurrencySign } from '../../utils/utils'
import Notification from '../Utils/Notification'

const Modal = ({ handleClose, showModal, headerText, children }) => {
  const showHideClassName = showModal
    ? 'modal-aaa aaa-display-block custodian-modal'
    : 'modal-aaa aaa-display-none'

  return (
    <div className={showHideClassName}>
      <section className="modal-aaa-main">
        <div className="modal-header">
          <h4>{headerText}</h4>
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        {children}
      </section>
    </div>
  )
}

class CustodianProfile extends Component {
  constructor(props) {
    super(props)
    const u = this.props.auth.user
    this.state = {
      emailVerificationSent: false,
      loading: false,
      responseMessage: null,
      errorMessage: null,
      priceData: null,
      currencySign: null,
      membershipFee: u.membershipFee,
      user: u,
      member: u.customer,
      reason: '',
      modalIsOpen: false,
      cancelIsLoading: false,
      cancelConfirmationIsLoading: false,
      emailLoading: false,
    }
  }

  openModal = () => {
    this.setState({ modalIsOpen: true })
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  handleReasonChange = (input) => {
    this.setState({ reason: input.target.value })
  }

  requestEmail = () => {
    this.setState({ emailLoading: true })
    axios
      .post('/api/verify-email')
      .then(() => {
        this.setState({ emailVerificationSent: true })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })
      .finally(() => {
        this.setState({ emailLoading: false })
      })
  }

  componentDidMount() {
    if (!this.props.auth.user) {
      console.log('no user...')
    }

    const getPricing = async () => {
      const data = await setPricing(
        this.props.auth.user.currencyValue,
        this.props.auth.user.discountCode
      )
      this.setState({
        priceData: data.membershipFee.toString(),
      })
    }
    const getCurrency = async () => {
      const data = await getCurrencySign(this.props.auth.user.currencyValue)
      this.setState({
        currencySign: data.sign,
      })
    }
    getPricing()
    getCurrency()
  }

  cancelMembership = () => {
    this.setState({
      loading: true,
      cancelIsLoading: true,
      cancelConfirmationIsLoading: true,
    })
    const that = this
    axios
      .post('/api/custodian/cancel-membership', { reason: that.state.reason })
      .then((response) => {
        if (response.data.success == true) {
          Notification({
            type: 'success',
            message: 'The membership has been cancelled. Logging you off...',
          })
        } else {
          Notification({
            type: 'error',
            message: 'Error trying to cancel the membership',
          })
        }
        setTimeout(function () {
          that.props.auth.handleLogout()
        }, 2000)
      })
      .catch(function (error) {
        that.setState({
          errorMessage: 'Error trying to cancel the membership',
        })
      })
      .finally(() => that.setState({ loading: false }))
  }

  render() {
    const u = this.props.auth.user

    let userCountry = this.props.search.countries.find(
      (c) => c.id === u.countryId
    )
    userCountry = userCountry ? userCountry.nicename : null
    let userCity = u.city_location ? u.city_location.city : null

    let memberCountry = this.props.search.countries.find(
      (c) => c.id === u.customer.countryId
    )
    memberCountry = memberCountry ? memberCountry.nicename : null
    let memberCity = u.customer.city_location
      ? u.customer.city_location.city
      : null

    if (!u.status || !this.state.priceData || !this.state.currencySign) {
      return null
    }
    return (
      <Fragment>
        <section className="contact-wrapper">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="contact_form">
                  <div className="profile-wrapper">
                    <h4 className="profile-title">Your identity</h4>
                    <h6>Name</h6>
                    <p>
                      {u.title} {u.forename} {u.surname}
                    </p>
                    <h6>Date of birth</h6>
                    <p>{moment(u.dob).format('DD/MM/YYYY')}</p>
                    <h6>Country</h6>
                    <p>{userCountry}</p>
                    <h6>City</h6>
                    <p>{userCity}</p>
                  </div>
                  <div className="profile-wrapper">
                    <h4 className="profile-title">Your Member</h4>
                    <h6>Name</h6>
                    <p>
                      {this.state.member.title} {this.state.member.forename}{' '}
                      {this.state.member.surname}
                    </p>
                    <h6>Date of birth</h6>
                    <p>{moment(this.state.member.dob).format('DD/MM/YYYY')}</p>
                    <h6>Country</h6>
                    <p>{memberCountry}</p>
                    <h6>City</h6>
                    <p>{memberCity}</p>
                    <hr />
                    <div className="row ml-1">
                      {this.state.cancelIsLoading ? (
                        <button
                          className="btn btn-primary"
                          type="button"
                          disabled
                        >
                          Cancelling{' '}
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary"
                          type="button"
                          onClick={this.openModal}
                        >
                          Cancel Account Membership
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="profile-wrapper">
                    <h4 className="profile-title">Your email</h4>
                    <h6>Email</h6>
                    <p>{u.email}</p>
                    {u.emailStatus === 'verified' ? (
                      <span className="badge badge-success">
                        <i className="fa fa-check" /> Email address verified
                      </span>
                    ) : (
                      <div>
                        <div className="row pb-3 ml-1">
                          <span className="badge badge-warning">
                            <i className="fa fa-exclamation-triangle" /> Email
                            address not verified
                          </span>
                        </div>
                        <div className="row ml-1">
                          {!this.state.emailVerificationSent ? (
                            this.state.emailLoading ? (
                              <button
                                className="btn btn-primary"
                                type="button"
                                disabled
                              >
                                Sending{' '}
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              </button>
                            ) : (
                              <button
                                className="btn btn-primary"
                                onClick={this.requestEmail}
                              >
                                Resend Verification Email
                              </button>
                            )
                          ) : (
                            <button className="btn btn-primary" disabled>
                              Verification Email Sent
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                    <hr />

                    <Link to="/dashboard/edit-email">
                      <button className="btn btn-primary">
                        Edit Email Address
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Modal
          showModal={this.state.modalIsOpen}
          handleClose={this.closeModal}
          headerText={'Membership cancellation'}
        >
          <div className="p-3">
            <h5>
              Are you sure? Please let us know why you would like to cancel your
              membership in the text field below then click the button to send
              the cancellation request
            </h5>
            <div className="d-flex flex-wrap">
              <textarea
                id="reason"
                name="reason"
                value={this.state.reason}
                onChange={this.handleReasonChange}
              />
            </div>
          </div>
          <div className="modal-footer justify-content-between">
            <button
              className="btn btn-secondary"
              type="button"
              onClick={this.closeModal}
            >
              Close
            </button>
            {this.state.cancelConfirmationIsLoading ? (
              <button className="btn btn-red" type="button" disabled>
                Cancelling{' '}
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              </button>
            ) : (
              <button
                className="btn btn-red"
                type="button"
                onClick={(e) => {
                  this.cancelMembership()
                  this.closeModal()
                }}
              >
                Cancel the account
              </button>
            )}
          </div>
        </Modal>
      </Fragment>
    )
  }
}

export default withRouter(withAuth(withSearch(CustodianProfile)))
